// import assets from '../components/traceEquipment/assets.vue';
// import inspection from '../components/traceEquipment/inspection.vue';
// import maintenance from '../components/traceEquipment/maintenance.vue'
// import newAssets from '../components/traceEquipment/newAssets.vue';
// import newMaintenance from '../components/traceEquipment/newMaintenance.vue'
// import personalXjMsg from '../components/traceEquipment/personalXjMsg.vue';
// import statisticalFx from '../components/traceEquipment/statisticalFx.vue';
// import traceEquipment from '../components/traceEquipment/traceEquipment.vue';
// import viewAssets from '../components/traceEquipment/viewAssets.vue';
// import viewInspection from '../components/traceEquipment/viewInspection.vue';
// import viewMaintenance from '../components/traceEquipment/viewMaintenance.vue';
// import ftpFile from '../components/traceEquipment/ftpFile.vue';
// import jxsjMonitor from '../components/traceEquipment/jxsjMonitor.vue';
// import journal from '../components/traceEquipment/journal.vue';
// import viewJournal from '../components/traceEquipment/viewJournal.vue';
// import contrast from '../components/traceEquipment/contrast.vue';
// import wjscSituation from '../components/traceEquipment/wjscSituation.vue';
// import zjjxSituation from '../components/traceEquipment/zjjxSituation.vue';
// import glContrast from '../components/traceEquipment/glContrast.vue';
// import changeGl from '../components/traceEquipment/changeGl.vue';
// import viewChangeGl from '../components/traceEquipment/viewChangeGl.vue';
// import inventoryList from '../components/traceEquipment/inventoryList.vue';
// import viewInventory from '../components/traceEquipment/viewInventory.vue';
// import equipmentYwList from '../components/traceEquipment/equipmentYwList.vue';
// import addEquipmentYw from '../components/traceEquipment/addEquipmentYw.vue';
// import viewEquipmentYw from '../components/traceEquipment/viewEquipmentYw.vue';
// import settlementList from '../components/traceEquipment/settlementList.vue';
// import viewSettlement from '../components/traceEquipment/viewSettlement.vue';
// import notOnlineList from '../components/traceEquipment/notOnlineList.vue';

export default [
    {
        path: 'traceEquipment/assets',
        component:resolve => require(['@/components/traceEquipment/assets'],resolve),
        name:"Assets",
        meta:{
            id:'278',
            node:'traceEquipment',
            url:'assets',
        }
    },
    {
        path: 'traceEquipment/inspection',
        component:  resolve => require(['@/components/traceEquipment/inspection'],resolve),
        name:'Inspection',
        meta:{
            id:'282',
            node:'traceEquipment',
            url:'inspection',
        }
    },
    {
        path: 'traceEquipment/maintenance',
        component:  resolve => require(['@/components/traceEquipment/maintenance'],resolve),
        name:'Maintenance',
        meta:{
            id:'286',
            node:'traceEquipment',
            url:'maintenance',
        }
    },
    {
        path: 'traceEquipment/newAssets',
        component:  resolve => require(['@/components/traceEquipment/newAssets'],resolve),
        name:'NewAssets',
        meta:{
            id:'279',
            node:'traceEquipment',
            url:'newAssets',
        }
    },
    {
        path: 'traceEquipment/newMaintenance',
        component:  resolve => require(['@/components/traceEquipment/newMaintenance'],resolve),
        name:'NewMaintenance',
        meta:{
            id:'287',
            node:'traceEquipment',
            url:'newMaintenance',
        }
    },
    {
        path: 'traceEquipment/personalXjMsg',
        component:  resolve => require(['@/components/traceEquipment/personalXjMsg'],resolve),
        name:'PersonalXjMsg',
        meta:{
            id:'283',
            node:'traceEquipment',
            url:'personalXjMsg',
        }
    },
    {
        path: 'traceEquipment/statisticalFx',
        component:resolve => require(['@/components/traceEquipment/statisticalFx'],resolve),
        name:"StatisticalFx",
        meta:{
            id:'290',
            node:'traceEquipment',
            url:'statisticalFx',
        }
    },
    {
        path: 'traceEquipment/traceEquipment',
        component:  resolve => require(['@/components/traceEquipment/traceEquipment'],resolve),
        name:'TraceEquipment',
        meta:{
            id:'276',
            node:'traceEquipment',
            url:'traceEquipment',
        }
    },
    {
        path: 'traceEquipment/viewAssets',
        component:  resolve => require(['@/components/traceEquipment/viewAssets'],resolve),
        name:'ViewAssets',
        meta:{
            id:'280',
            node:'traceEquipment',
            url:'viewAssets',
        }
    },
    {
        path: 'traceEquipment/viewInspection',
        component:  resolve => require(['@/components/traceEquipment/viewInspection'],resolve),
        name:'ViewInspection',
        meta:{
            id:'284',
            node:'traceEquipment',
            url:'viewInspection',
        }
    },
    {
        path: 'traceEquipment/viewMaintenance',
        component:  resolve => require(['@/components/traceEquipment/viewMaintenance'],resolve),
        name:'ViewMaintenance',
        meta:{
            id:'288',
            node:'traceEquipment',
            url:'viewMaintenance',
        }
    },
    {
        path: 'traceEquipment/ftpFile',
        component:  resolve => require(['@/components/traceEquipment/ftpFile'],resolve),
        name:'FtpFile',
        meta:{
            id:'372',
            node:'traceEquipment',
            url:'ftpFile',
        }
    },
    {
        path: 'traceEquipment/jxsjMonitor',
        component:  resolve => require(['@/components/traceEquipment/jxsjMonitor'],resolve),
        name:'JxsjMonitor',
        meta:{
            id:'374',
            node:'traceEquipment',
            url:'jxsjMonitor',
        }
    },
    {
        path: 'traceEquipment/journal',
        component:  resolve => require(['@/components/traceEquipment/journal'],resolve),
        name:'Journal',
        meta:{
            id:'369',
            node:'traceEquipment',
            url:'journal',
        }
    },
    {
        path: 'traceEquipment/viewJournal',
        component:  resolve => require(['@/components/traceEquipment/viewJournal'],resolve),
        name:'ViewJournal',
        meta:{
            id:'370',
            node:'traceEquipment',
            url:'viewJournal',
        }
    },
    {
        path: 'traceEquipment/contrast',
        component:  resolve => require(['@/components/traceEquipment/contrast'],resolve),
        name:'Contrast',
        meta:{
            id:'380',
            node:'traceEquipment',
            url:'contrast',
        }
    },
    {
        path: 'traceEquipment/wjscSituation',
        component:  resolve => require(['@/components/traceEquipment/wjscSituation'],resolve),
        name:'WjscSituation',
        meta:{
            id:'378',
            node:'traceEquipment',
            url:'wjscSituation',
        }
    },
    {
        path: 'traceEquipment/zjjxSituation',
        component:  resolve => require(['@/components/traceEquipment/zjjxSituation'],resolve),
        name:'ZjjxSituation',
        meta:{
            id:'379',
            node:'traceEquipment',
            url:'zjjxSituation',
        }
    },
    {
        path: 'traceEquipment/glContrast',
        component:  resolve => require(['@/components/traceEquipment/glContrast'],resolve),
        name:'GlContrast',
        meta:{
            id:'376',
            node:'traceEquipment',
            url:'glContrast',
        }
    },
    {
        path: 'traceEquipment/changeGl',
        component:  resolve => require(['@/components/traceEquipment/changeGl'],resolve),
        name:'ChangeGl',
        meta:{
            id:'386',
            node:'traceEquipment',
            url:'changeGl',
        }
    },
    {
        path: 'traceEquipment/viewChangeGl',
        component:  resolve => require(['@/components/traceEquipment/viewChangeGl'],resolve),
        name:'ViewChangeGl',
        meta:{
            id:'387',
            node:'traceEquipment',
            url:'viewChangeGl',
        }
    },
    {
        path: 'traceEquipment/inventoryList',
        component:  resolve => require(['@/components/traceEquipment/inventoryList'],resolve),
        name:'InventoryList',
        meta:{
            id:'813',
            node:'traceEquipment',
            url:'inventoryList',
        }
    },
    {
        path: 'traceEquipment/viewInventory',
        component:  resolve => require(['@/components/traceEquipment/viewInventory'],resolve),
        name:'ViewInventory',
        meta:{
            id:'814',
            node:'traceEquipment',
            url:'viewInventory',
        }
    },
    {
        path: 'traceEquipment/equipmentYwList',
        component:  resolve => require(['@/components/traceEquipment/equipmentYwList'],resolve),
        name:'EquipmentYwList',
        meta:{
            id:'819',
            node:'traceEquipment',
            url:'equipmentYwList',
        }
    },
    {
        path: 'traceEquipment/addEquipmentYw',
        component:  resolve => require(['@/components/traceEquipment/addEquipmentYw'],resolve),
        name:'AddEquipmentYw',
        meta:{
            id:'821',
            node:'traceEquipment',
            url:'addEquipmentYw',
        }
    },
    {
        path: 'traceEquipment/viewEquipmentYw',
        component:  resolve => require(['@/components/traceEquipment/viewEquipmentYw'],resolve),
        name:'ViewEquipmentYw',
        meta:{
            id:'822',
            node:'traceEquipment',
            url:'viewEquipmentYw',
        }
    },
    {
        path: 'traceEquipment/settlementList',
        component:  resolve => require(['@/components/traceEquipment/settlementList'],resolve),
        name:'SettlementList',
        meta:{
            id:'820',
            node:'traceEquipment',
            url:'settlementList',
        }
    },
    {
        path: 'traceEquipment/viewSettlement',
        component:  resolve => require(['@/components/traceEquipment/viewSettlement'],resolve),
        name:'ViewSettlement',
        meta:{
            id:'823',
            node:'traceEquipment',
            url:'viewSettlement',
        }
    },
    {
        path: 'traceEquipment/notOnlineList',
        component:  resolve => require(['@/components/traceEquipment/notOnlineList'],resolve),
        name:'NotOnlineList',
        meta:{
            // id:'823',
            node:'traceEquipment',
            url:'notOnlineList',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/traceEquipment.js